<template>
  <div
    id="customerOrdersImagesModal"
    class="modal fade"
  >
    <div
      class="modal-dialog modal-full"
      style="max-width: 900px"
    >
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            @click="closeModal('customerOrdersImagesModal')"
          >
            &times;
          </button>
          <h3 class="modal-title">{{ $t('orderDeliveryCustomerImages.title') }}</h3>
          <div
            v-if="customerName"
            style="font-size: 13px; color: #666;"
          >{{ customerName }}</div>
        </div>

        <div class="modal-body">
          <div
            v-if="!orders.length"
            style="text-align: center; color: #999; padding: 24px;"
          >{{ $t('orderDeliveryCustomerImages.noOrdersFound') }}</div>

          <div
            v-else-if="!isMobile"
            class="print-scroll-x"
          >
            <table style="width: 100%; min-width: 650px; border-collapse: collapse; border: 1px solid #000;">
              <thead>
                <tr style="background-color: #f2f2f2; font-size: 13px;">
                  <th style="border: 1px solid #000; padding: 6px; text-align: center;">#</th>
                  <th style="border: 1px solid #000; padding: 6px;">{{ $t('columns.orderHash') }}</th>
                  <th style="border: 1px solid #000; padding: 6px;">{{ $t('orderDeliveryCustomerImages.productLabel') }}</th>
                  <th style="border: 1px solid #000; padding: 6px; text-align: center;">{{ $t('invoice.shippingInvoiceTitle') }}</th>
                  <th style="border: 1px solid #000; padding: 6px; text-align: center;">{{ $t('orderDeliveryCustomerImages.imagesLabel') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(order, index) in orders"
                  :key="order.order_id"
                  style="font-size: 13px;"
                >
                  <td style="border: 1px solid #000; padding: 5px; text-align: center;">{{ index + 1 }}</td>
                  <td style="border: 1px solid #000; padding: 5px;">{{ order.theOrderID }}</td>
                  <td style="border: 1px solid #000; padding: 5px;">{{ order.product_name }}</td>
                  <td style="border: 1px solid #000; padding: 5px; text-align: center;">
                    <span v-if="order.order_invoice">{{ order.order_invoice.invoice_number }}</span>
                    <span
                      v-else
                      style="color: #bbb;"
                    >{{ $t('orderDeliveryCustomerImages.notInvoiced') }}</span>
                  </td>
                  <td style="border: 1px solid #000; padding: 5px;">
                    <div style="display: flex; flex-wrap: wrap; gap: 6px; justify-content: center;">
                      <img
                        v-for="(img, i) in order.photos"
                        :key="i"
                        :src="imageUrl(img)"
                        :alt="$t('columns.image')"
                        width="48"
                        height="48"
                        style="border-radius: 4px; object-fit: cover; cursor: pointer;"
                        @click="lightboxImage = imageUrl(img); lightboxOpen = true"
                      />
                      <span
                        v-if="!order.photos || !order.photos.length"
                        style="color: #bbb; font-size: 11px;"
                      >—</span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div
            v-else
            class="moc-container"
          >
            <div
              v-for="(order, index) in orders"
              :key="order.order_id"
              class="moc-card"
              style="margin-bottom: 12px;"
            >
              <div class="moc-header">
                <span class="moc-item-code">#{{ index + 1 }} · {{ order.theOrderID }}</span>
                <span
                  class="moc-status-badge"
                  :style="order.order_invoice
                    ? { backgroundColor: '#89D7B7', color: '#1A5940' }
                    : { backgroundColor: '#E0E0E0', color: '#616161' }"
                >{{ order.order_invoice ? order.order_invoice.invoice_number : $t('orderDeliveryCustomerImages.notInvoiced') }}</span>
              </div>
              <div class="moc-body">
                <div
                  v-if="order.product_name"
                  class="moc-row"
                >
                  <span class="moc-label">{{ $t('orderDeliveryCustomerImages.productLabel') }}</span>
                  <span class="moc-value">{{ order.product_name }}</span>
                </div>
                <div class="moc-row">
                  <span class="moc-label">{{ $t('orderDeliveryCustomerImages.imagesLabel') }}</span>
                  <span class="moc-value">
                    <div style="display: flex; flex-wrap: wrap; gap: 6px;">
                      <img
                        v-for="(img, i) in order.photos"
                        :key="i"
                        :src="imageUrl(img)"
                        :alt="$t('columns.image')"
                        width="48"
                        height="48"
                        style="border-radius: 4px; object-fit: cover; cursor: pointer;"
                        @click="lightboxImage = imageUrl(img); lightboxOpen = true"
                      />
                      <span
                        v-if="!order.photos || !order.photos.length"
                        style="color: #bbb; font-size: 11px;"
                      >—</span>
                    </div>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer"></div>
      </div>
    </div>

    <v-dialog
      v-model="lightboxOpen"
      max-width="600px"
    >
      <v-card>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="lightboxOpen = false"
          ><v-icon>close</v-icon></v-btn>
        </v-card-actions>
        <v-card-text style="text-align: center; padding-top: 0;">
          <img
            :src="lightboxImage"
            style="max-width: 100%; max-height: 80vh;"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: ['viewData', 'closeModal'],

  data() {
    return {
      isMobile: false,
      lightboxOpen: false,
      lightboxImage: null
    }
  },

  mounted() {
    this.isMobile = screen.width <= 600
  },

  computed: {
    orders() {
      return (this.viewData && this.viewData.data) || []
    },

    customerName() {
      return this.viewData && this.viewData.customer_name
    }
  },

  methods: {
    imageUrl(filename) {
      return filename && filename.startsWith('http') ? filename : `${this.$_image_path()}${filename}`
    }
  }
}
</script>

<style>
@media screen and (max-width: 767px) {
  /* Bootstrap's vertical-centering trick (.modal:before + .modal-dialog's vertical-align:
     middle, from the global theme CSS) centers short dialogs fine, but once this dialog's
     content is taller than the phone screen, centering an oversized box pushes its top below
     the viewport's top edge — you have to scroll past dead space just to reach the top of the
     dialog. Same fix as orderDeliveryInvoice.vue's #orderDeliveryModal, scoped to this modal's
     own id so other dialogs elsewhere in the app keep their centered behavior. */
  #customerOrdersImagesModal:before {
    display: none;
  }
  #customerOrdersImagesModal .modal-dialog {
    display: block;
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/orderDelivery/orderDeliveryCustomerImages.vue